/**
 * @desc 根据sku查询箱码列表
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierPad.getBoxListBySku.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierPAD/getBoxListBySku`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
